import { BugFilled,StarFilled,SlidersFilled  } from "@ant-design/icons";


import { DiseaseIcon,PestIcon,WeedIcon } from "./icons";

// icons
const icons = {
  BugFilled,
  StarFilled,
  SlidersFilled,
  DiseaseIcon,
  PestIcon,
  WeedIcon


};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const ddpsPages = {
  id: "ddps-pages",
  title: "Pages",
  type: "group",
  app: 'ddps',
  children: [
    {
      id: "pests",
      title: "Insects",
      type: "item",
      url: "/ddps/insects/select-entities-and-weather-station",
      icon: icons.PestIcon,
      breadcrumbs: false,
    },
    {
      id: "disease-crops",
      title: "Diseases",
      type: "item",
      url: "",
      icon: icons.DiseaseIcon,
      breadcrumbs: false,
    },
    {
        id: "weeds",
        title: "Weeds",
        type: "item",
        url: "",
        icon: icons?.WeedIcon,
        breadcrumbs: false,
      },
  ],
};

export default ddpsPages;
